import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    Box, Flex, Icon, Text
} from 'components/ui';
import Empty from 'constants/empty';

const selectPaymentBannerMessages = state =>
    (Array.isArray(state?.order?.paymentPromoBanner) ? state.order.paymentPromoBanner : Empty.Array);

function PaymentPromoBanner({ paddingTop = 5 }) {
    const messages = useSelector(selectPaymentBannerMessages, shallowEqual);

    if (!messages.length) {
        return null;
    }

    return (
        <Box
            paddingTop={paddingTop}
            width='100%'
        >
            {messages.map((message, index) => (
                <Flex
                    key={`${message}_${index}`}
                    lineHeight='tight'
                    backgroundColor='nearWhite'
                    marginTop={index === 0 ? 0 : 2}
                    paddingX={3}
                    paddingY={2}
                    borderRadius={2}
                    role='alert'
                >
                    <Icon
                        name='alert'
                        color='midGray'
                        marginRight={2}
                        size={18}
                    />
                    <Text
                        is='p'
                        flex={1}
                        alignSelf='center'
                        data-at={Sephora.debug.dataAt(`payment_promo_banner_${index}`)}
                    >
                        {message}
                    </Text>
                </Flex>
            ))}
        </Box>
    );
}

export default wrapFunctionalComponent(PaymentPromoBanner, 'PaymentPromoBanner');
